// Teklif PDF'i üretimi — HTML/PDF sunucuda üretilir, istemci sadece veriyi gönderir.
// Önizleme ve indirme AYNI blob üzerinden çalışır; böylece ekranda görülen
// belge ile indirilen dosya birebir aynıdır.

import { generatePDFFileName } from "../Components/OfferGenerator/pdfFileNameGenerator";
import { useGeneratePDFMutation } from "../store/storageRoles/offerApi";

/** Hazır bir blob'u tarayıcıya indirtir. */
export const downloadBlob = (blob, fileName) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    throw new Error("Web ortamı bulunamadı");
  }
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const useGenerateMultiProductPDF = () => {
  const [generatePDF, { isLoading, error }] = useGeneratePDFMutation();

  /** PDF'i üretir ve blob'u döner (indirme yapmaz). */
  const createMultiProductPDF = async (data, token) => {
    const allProductTypes = data.products.map((p) => p.productType);
    const fileName = generatePDFFileName(data.brandName, allProductTypes);

    const blob = await generatePDF({
      data,
      fileName,
      token,
    }).unwrap();

    return { blob, fileName };
  };

  /** PDF'i üretip doğrudan indirir. */
  const generateMultiProductPDF = async (data, token) => {
    const { blob, fileName } = await createMultiProductPDF(data, token);
    downloadBlob(blob, fileName);
    return { blob, fileName };
  };

  return {
    createMultiProductPDF,
    generateMultiProductPDF,
    isLoading,
    error,
  };
};
